"use client";

import React, { memo } from "react";
import styles from "./aurora-text.module.css";

interface AuroraTextProps {
  children: React.ReactNode;
  className?: string;
  colors?: string[];
  speed?: number;
}

export const AuroraText = memo(
  ({
    children,
    className = "",
    colors = ["#D4A84B", "#E5C06D", "#D4A84B", "#C09540"],
    speed = 1,
  }: AuroraTextProps) => {
    const gradientStyle: React.CSSProperties = {
      backgroundImage: `linear-gradient(90deg, ${colors.join(", ")})`,
      animationDuration: `${6 / speed}s`,
    };

    return (
      <span className={`relative inline-block ${className}`}>
        <span className={styles.auroraText} style={gradientStyle}>
          {children}
        </span>
      </span>
    );
  },
);

AuroraText.displayName = "AuroraText";
